module.exports = __webpack_public_path__ + "img/gallery.e443eb0d.jpg";